import { gql } from '@apollo/client'

export const createUserCodeRedemptionMutation = gql`
  mutation CreateUserCodeRedemption($user: String, $code: String) {
    UserCodeRedemptionCreateOne(record: { user: $user, code: $code }) {
      recordId
    }
  }
`
